// extracted by mini-css-extract-plugin
export default {"mail":"MailTo_mail__ORqJZ","not-underlined":"MailTo_not-underlined__589kI"};